import axios from 'axios'
import { Modal, Message, Spin } from 'view-design'
import cookie from 'vue-cookies';
import vue from "../main"
import util from "@/libs/util"

var root = process.env.API_URL;
var spinHideTimeout = {}

const ajaxRequest = axios.create({
  baseURL: root,
  headers: {
    // 'Content-Type': 'application/json;charset=utf-8'
  }
})

ajaxRequest.interceptors.request.use(
  request => {
    vue.$store.commit("add_ajax_spin")
    clearTimeout(spinHideTimeout)
    Spin.show();

    return request;
  },
  error => {

    console.info(error);
  }
)
ajaxRequest.interceptors.response.use(
  async res => {
    console.info("download", res)

    if (res.config.url.indexOf("/ping") < 0) {
      vue.$store.commit("sub_ajax_spin")
      let ajax_count = vue.$store.getters.get_ajax_count
      if (ajax_count <= 0) {
        spinHideTimeout = setTimeout(() => {
          Spin.hide();
        }, 250)
      }
    }

    var data = res.data;
    //如果返回的是BLOB的内容，则直接返回
    if (res.request.responseType == "blob") {
      if (data.type == "application/json") {
        data = await data.text();
        console.info(data);
        data = JSON.parse(data);
      } else {
        return res.data;
      }
    }

    // //如果返回的是BLOB的内容，则直接返回
    // if(res.data.type && res.data.type == "application/octet-stream"){
    //   return res.data;
    // }
  },
  error => {
    console.info(error);
    vue.$store.commit("sub_ajax_spin")
    let ajax_count = vue.$store.getters.get_ajax_count
    if (ajax_count <= 0) {
      spinHideTimeout = setTimeout(() => {
        Spin.hide();
      }, 250)
    }
    // Modal.error({
    //   title: "SYSTEM ERROR",
    //   content: error + "<br/>YOU CAN TRY TO RELOAD THIS PAGE OR CONTACT WITH ADMIN",
    //   okText: "OK",
    // });
  }
)

export default ajaxRequest



// WEBPACK FOOTER //
// ./src/api/ajax_download.js